import { Container, Grid, Typography, Box, Button } from '@material-ui/core';
import React, { useEffect } from 'react';
import Aos from 'aos'
import "aos/dist/aos.css"
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

import IGSABanner from "../../asset/images/igsa/banner/igsa_banner.webp";

import processing4 from "../../asset/images/igsa/applications/smarter-decisions.webp";
import processing5 from "../../asset/images/igsa/applications/scalable-solution.webp";
import processing6 from "../../asset/images/igsa/applications/future-ready-strategies.webp";

import adv1 from "../../asset/images/igsa/applications/ai-powered-forecasting.webp";
import adv2 from "../../asset/images/igsa/applications/end-to-end-supply-chain-visibility.webp";
import adv3 from "../../asset/images/igsa/applications/optimized-operations.webp";
import adv4 from "../../asset/images/igsa/applications/risk-mitigation.webp";

import IGSALabsContactUs from '../../Component/forms/IGSALabsContactUs';
import supply_chain from "../../asset/images/igsa/supply_chain.webp"

export default function IGSALabs() {

    useEffect(() => {
        Aos.init({ duration: 1000 });
    }, []);

    // Scroll to form started
    const scrollToElement = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const stickyItemsHeight = 30;
            const offset = element.getBoundingClientRect().top - stickyItemsHeight;


            setTimeout(() => {
                window.scrollBy({ top: offset, behavior: 'smooth' });
            }, 50);
        }
    };

    useEffect(() => {
        const { hash } = window.location;
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                const offset = 50;
                const elementPosition = element.getBoundingClientRect().top;
                const offsetPosition = elementPosition - offset;
                window.scrollBy({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }
    }, []);
    // Scroll to form ended

    return (
        <>

            <Helmet>
                <meta charset="UTF-8" />
                <title> Transform Supply Chain Analytics with AI | IGSA Labs Partnership </title>
                <meta name="description" content="Explore how Decimal Point Analytics and IGSA Labs are transforming supply chains with AI forecasting, real-time visibility & smarter data-driven operations." />
                <meta name="author" content="Decimal Point Analytics" />
                <link rel="canonical" href="https://www.decimalpointanalytics.com/igsa-labs" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
            </Helmet>

            <Box id="headingdbricks">
                <Box id="new_landing_carousel" className='ibmbanner'>
                    <Box className="mainsection1" component="section" style={{ backgroundImage: "url(" + IGSABanner + ")" }} pb={2}>
                        <Container maxWidth="lg">
                            <Grid container spacing={1} alignItems="center" justifyContent='center'>
                                <Grid item lg={12} md={12} sm={11} xs={10}>
                                    <Box className="text_animated mb0">
                                        <Typography variant="h1" className="blue fw6 mb0" gutterBottom>
                                            Bringing Analytics <span className='lower'>to</span> Supply Chain
                                        </Typography>

                                        <Box>
                                            <Typography variant="h2" className="black3" gutterBottom>
                                                <span className='fw4'> DPA Partners <span className='lower'>with</span> IGSA Labs <span className='lower'>to</span> Transform Supply Chain Analytics</span>
                                            </Typography>
                                        </Box>

                                        <Box mt={2}>
                                            <Link to="/igsa-labs#igsalabscontactus" onClick={() => scrollToElement('igsalabscontactus')}>
                                                <Button variant="contained" className='dpabtn_sm1'>
                                                    Get In Touch
                                                </Button>
                                            </Link>
                                        </Box>

                                    </Box>
                                </Grid>

                            </Grid>
                        </Container>
                    </Box>
                </Box>
            </Box>

            <Box className='section mob_card' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={2} alignItems="flex-start" justifyContent='center'>

                        <Grid item lg={5} md={5} sm={6} xs={12}>
                            <Box className='al_center'>
                                <img loading="lazy" src={supply_chain} className='w100' alt='Decimal Point Analytics + IGSA: Transforming Supply Chain Intelligence' />
                            </Box>
                        </Grid>

                        <Grid item lg={7} md={7} sm={6} xs={12}>
                            <Box mt={2}>

                                <Typography variant="h2" className="fw5" gutterBottom>
                                    Decimal Point Analytics + IGSA: Transforming Supply Chain Intelligence
                                </Typography>

                                <Typography variant='h6' className='black mb0 al_left' >
                                    Decimal Point Analytics (DPA) is excited to announce its partnership with IGSA Labs, a pioneer in AI-driven supply chain strategy, planning, and execution. Together, we will empower businesses to unlock efficiency, agility, and data-driven decision-making across their supply chains.
                                </Typography>

                                <Typography variant='h6' className='black al_left' gutterBottom>
                                    Our partnership empowers manufacturers with actionable insights, driven by AI, to transform supply chains and improve clients’ bottomlines.
                                </Typography>

                                <Typography variant='h6' className='black al_left' gutterBottom>
                                    <strong>Want to learn how this partnership can help your business? <Link className="link" to="/contact-us#contact_form">Contact us</Link></strong>.
                                </Typography>

                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={3} alignItems="center" justifyContent='left'>

                        <Grid container spacing={1} alignItems="top">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='al_center'>
                                    <Typography variant='h2' className='black mb0'>
                                        How DPA and IGSA Labs Create Value
                                    </Typography>
                                </Box>
                            </Grid>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv1} className='allic' alt='AI-Powered Forecasting' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>AI-Powered Forecasting:</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Combine DPA’s predictive analytics with IGSA’s demand modeling for hyper-accurate forecasts.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv2} className='allic' alt='End-to-End Supply Chain Visibility' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>End-to-End Supply Chain Visibility:</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Unified dashboards tracking procurement, logistics, and inventory in real time.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv3} className='allic' alt='Optimized Operations' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Optimized Operations:</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        AI-driven recommendations for S&OP, procurement, and route planning to cut waste and improve margins.
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Box className="ora_app flx_fs align_c alignmob">
                                <Box className='ora_app_iconbx' mr={1}>
                                    <img loading="lazy" src={adv4} className='allic' alt='Risk Mitigation' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_left" gutterBottom>Risk Mitigation:</Typography>

                                    <Typography variant="h6" className="black al_left jst">
                                        Scenario modeling to anticipate disruptions (e.g. demand spikes, supplier delays).
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section mob_card' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={2} alignItems="center" justifyContent='center'>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className='al_center'>
                                <Typography variant='h2' className='black'>
                                    Real-World Success Stories by IGSA
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box id="new_innovation_design" className="reportinfo">
                                <Grid container spacing={2} alignItems="top" justifyContent="center">
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <Box className='reportinfo'>
                                            <Box className="reportm_bg reporttmht">
                                                <Box pb={2}>
                                                    <Button variant="contained" className='ora_title_btn'>
                                                        Case Study
                                                    </Button>
                                                </Box>

                                                <Box mt={2} mb={1}>
                                                    <Typography variant='h3' className='blue h3h4 mb0'>
                                                        AI-Driven Demand Forecasting for a Global Retailer
                                                    </Typography>
                                                </Box>

                                                <Box className="line"></Box>

                                                <Box mt={2}>
                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            Challenge:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            A multinational retail chain faced erratic demand patterns, leading to overstocking (increasing holding costs) and stockouts (lost sales).
                                                        </Typography>
                                                    </Box>

                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            IGSA Labs’ Solution:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            <ul className='m0'>
                                                                <li>
                                                                    Deployed an <strong>AI-powered demand forecasting model</strong> integrating historical sales, seasonality, and external factors (e.g., weather, promotions).
                                                                </li>
                                                                <li>
                                                                    Automated replenishment triggers to align inventory with real-time demand.
                                                                </li>
                                                            </ul>
                                                        </Typography>
                                                    </Box>

                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            Results:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            <ul className='m0'>
                                                                <li>
                                                                    <strong>30% reduction</strong> in excess inventory.
                                                                </li>
                                                                <li>
                                                                    <strong>18% improvement</strong> in stock availability, boosting revenue.
                                                                </li>
                                                                <li>
                                                                    <strong>98% forecast accuracy</strong> for high-demand SKUs.
                                                                </li>
                                                            </ul>
                                                        </Typography>
                                                    </Box>

                                                </Box>


                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <Box className='reportinfo'>
                                            <Box className="reportm_bg reporttmht">
                                                <Box pb={2}>
                                                    <Button variant="contained" className='ora_title_btn'>
                                                        Case Study
                                                    </Button>
                                                </Box>

                                                <Box mt={2} mb={1}>
                                                    <Typography variant='h3' className='blue h3h4 mb0'>
                                                        Sales & Operations Planning (S&OP) for a Manufacturing Giant
                                                    </Typography>
                                                </Box>
                                                <Box className="line"></Box>

                                                <Box mt={2}>
                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            Challenge:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            A heavy machinery manufacturer struggled with siloed planning, causing production delays and missed deadlines.
                                                        </Typography>
                                                    </Box>

                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            IGSA Labs’ Solution:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            <ul className='m0'>
                                                                <li>
                                                                    Implemented a unified <strong>S&OP platform</strong> synchronizing sales, procurement, and production data.
                                                                </li>
                                                                <li>
                                                                    Introduced <strong>scenario modeling</strong> to simulate disruptions (e.g., raw material shortages).
                                                                </li>
                                                            </ul>
                                                        </Typography>
                                                    </Box>

                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            Results:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            <ul className='m0'>
                                                                <li>
                                                                    <strong>22% faster</strong> planning cycles.
                                                                </li>
                                                                <li>
                                                                    <strong>15% cost savings</strong> via optimized procurement and production scheduling.
                                                                </li>
                                                                <li>
                                                                    <strong>40% reduction</strong> in manual planning efforts.
                                                                </li>
                                                            </ul>
                                                        </Typography>
                                                    </Box>

                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item lg={4} md={4} sm={12} xs={12}>
                                        <Box className='reportinfo'>
                                            <Box className="reportm_bg reporttmht">
                                                <Box pb={2}>
                                                    <Button variant="contained" className='ora_title_btn'>
                                                        Case Study
                                                    </Button>
                                                </Box>

                                                <Box mt={2} mb={1}>
                                                    <Typography variant='h3' className='blue h3h4 mb0'>
                                                        Route Optimization for a Logistics Leader
                                                    </Typography>
                                                </Box>
                                                <Box className="line"></Box>

                                                <Box mt={2}>
                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            Challenge:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            A logistics firm faced rising fuel costs and delayed deliveries due to inefficient route planning.
                                                        </Typography>
                                                    </Box>

                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            IGSA Labs’ Solution:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            <ul className='m0'>
                                                                <li>
                                                                    Developed a <strong>dynamic route optimization tool</strong> using real-time traffic, vehicle capacity, and delivery windows.
                                                                </li>
                                                                <li>
                                                                    Integrated <strong>AI-based vehicle assignment</strong> to minimize empty miles.
                                                                </li>
                                                            </ul>
                                                        </Typography>
                                                    </Box>

                                                    <Box py={'4px'}>
                                                        <Typography variant='h4' className='blue' gutterBottom>
                                                            Results:
                                                        </Typography>
                                                        <Typography variant='h6' className='black jst'>
                                                            <ul className='m0'>
                                                                <li>
                                                                    <strong>25% lower fuel costs.</strong>
                                                                </li>
                                                                <li>
                                                                    <strong>On-time deliveries improved by 35%.</strong>
                                                                </li>
                                                                <li>
                                                                    <strong>Reduced carbon footprint by 20%.</strong>
                                                                </li>
                                                            </ul>
                                                        </Typography>
                                                    </Box>

                                                </Box>
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item lg={12} md={12} sm={12} xs={12}>
                                        <Box mt={3}>
                                            <Typography variant='h6' className='black al_center' gutterBottom>
                                                Looking to solve similar challenges? <Link className="link" to="/contact-us#contact_form">We’re here to help</Link>.
                                            </Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section sec_bg' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container direction="row"
                        justifyContent="center"
                        alignItems="center">
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Box className="al_center">

                                <Typography variant='h2' className='black'>
                                    The Right Partnership <span className='lower'>for</span> Industrial Transformation
                                </Typography>

                                <Typography variant='h2' className='black'>
                                    Collaborative Implementation
                                </Typography>

                                <Typography variant='h6' className='black al_center' gutterBottom>
                                    We work alongside your teams—not just as technology providers, but as partners in problem-solving.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='sba_solutions' className='section mob_card databricks_card' component='section'>
                <Container maxWidth='lg' className='bdr'>
                    <Grid container spacing={3} alignItems="center" justifyContent='center'>

                        <Grid container spacing={1} alignItems="top">
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box className='al_center'>
                                    <Typography variant='h2' className='black'>
                                        Let’s Drive Your Supply Chain Efficiency
                                    </Typography>

                                    <Typography variant='h6' className='black al_center'>
                                        Supply chains are the backbone of global commerce—yet fragmented data and manual processes plague efficiency. Together, DPA and IGSA Labs provide:
                                    </Typography>
                                </Box>

                            </Grid>
                        </Grid>


                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties igsa_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing4} className='allic' alt='Autonomy and Self-Management' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_center" gutterBottom> Smarter Decisions: </Typography>
                                </Box>
                                <Typography variant="h6" className="black al_center">
                                    From raw material procurement to last-mile delivery.
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties igsa_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing5} className='allic' alt='Performance Acceleration' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_center" gutterBottom> Scalable Solutions: </Typography>
                                </Box>
                                <Typography variant="h6" className="black al_center">
                                    Cloud-based platforms adaptable to industries like manufacturing, retail, and logistics.
                                </Typography>
                            </Box>
                        </Grid>

                        <Grid item lg={4} md={4} sm={6} xs={12}>
                            <Box className="ora_experties igsa_cards">
                                <Box className='ora_iconbx'>
                                    <img loading="lazy" src={processing6} className='allic' alt='Security Fortification' />
                                </Box>
                                <Box mt={1} mb={2}>
                                    <Typography variant="h4" className="black al_center" gutterBottom> Future-Ready Strategies:</Typography>
                                </Box>
                                <Typography variant="h6" className="black al_center">
                                    Leveraging AI to stay ahead of market shifts.
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Box id='igsalabscontactus' className='sec_bg'>
                <IGSALabsContactUs />
            </Box>

        </>
    );
}
